import { QueryHookOptions } from '@apollo/client';

import {
  FetchAiSuggestionsForReviewCardV2Query,
  FetchAiSuggestionsForReviewCardV2QueryVariables,
  useFetchAiSuggestionsForReviewCardV2Query,
} from '../graphql/aiSuggestionReviewCardV2.generated';

type ReviewCardSuggestionsQueryOptions = QueryHookOptions<
  FetchAiSuggestionsForReviewCardV2Query,
  FetchAiSuggestionsForReviewCardV2QueryVariables
>;

interface UseFetchReviewCardSuggestionsOptions
  extends Omit<ReviewCardSuggestionsQueryOptions, 'variables'> {
  householdId: string | undefined;
}

export function useFetchReviewCardSuggestions({
  householdId,
  skip,
  ...options
}: UseFetchReviewCardSuggestionsOptions) {
  return useFetchAiSuggestionsForReviewCardV2Query({
    skip: skip || !householdId,
    variables: {
      householdID: householdId!,
    },
    ...options,
  });
}
